import { useField } from 'formik';
import MaterialTextField, { TextFieldProps as MaterialTextFieldProps } from '@mui/material/TextField';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  field: {
    margin: theme.spacing(1, 0, 2, 0),
    display: 'block',
  },
}));

type Props = {
  name: string;
  label?: string;
  disabled?: boolean;
  touched?: boolean;
  helperText?: React.ReactNode;
} & Omit<MaterialTextFieldProps, 'name' | 'label' | 'disabled' | 'helperText'>;

const TextField = ({ name, label, disabled, touched: formTouched, helperText, ...fieldProps }: Props) => {
  const { classes } = useStyles();
  const [field, meta] = useField(name);
  const touched = formTouched || meta.touched;
  const currentError = meta.error;

  return (
    <MaterialTextField
      id={name}
      label={label}
      {...field}
      value={field.value || ''}
      error={touched && Boolean(currentError)}
      helperText={(touched && currentError) || helperText}
      fullWidth
      disabled={disabled}
      variant="outlined"
      className={classes.field}
      {...fieldProps}
    />
  );
};

export default TextField;
